<template>
  <div class="friendlyLink">
    <div class="border-bottom">
      <h3>友情链接</h3>
      <div class="links">
        <div v-for="(item, index) in data" :key="index">
          <a :href="item.url">{{ item.title }}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Friendlinks',
  props: ['data']
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
.friendlyLink
  background: #f6f6f6
  padding: 20px 0
  .border-bottom
    width: 1200px
    margin: 0 auto
    padding: 4px 0 12px
    border-bottom-color: #ddd;
    h3
      color: #484848
      font-size: 16px
      height: 25px
      line-height: 25px
    .links
      overflow: hidden
      display: flex
      clear: both
      justify-content: space-between
      div
        line-height: 0
        text-align: center
        float:left
        margin-right :40px\9\0
        a
          line-height: 20px
          padding: 5px 0
          font-size: 12px
          color: #999
          &:hover
            color: $titbgcolor
        i
          color: red
          margin: 0 9px
</style>



// WEBPACK FOOTER //
// src/common-components/Friendlinks.vue